/* ═══════════════════════════════════════════════════════════════════════
   ALIA · THREE NIGHTS — assets/12-three-nights.js
   Route B: ALL theme JavaScript in ONE file, loaded with defer.

   Assembled from the original inline scripts in templates/index.liquid:
     · main engine   (was 936-1454)
     · mobile drawer (was 1457-1510)
     · CTA dock reveal (was 1538-1559)

   Code bodies are verbatim. The only structural change is that the
   ScrollTrigger-creating wiring now lives in a re-runnable function so the
   theme editor can inject, move and remove sections without stacking or
   orphaning timelines (trap H).

   ONE Lenis instance -> ONE ScrollTrigger registry, spanning every section.
   ═══════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";
  var $  = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var hasGSAP = typeof window.gsap !== 'undefined';
  var hasST   = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var hasSplit= hasGSAP && typeof window.SplitText !== 'undefined';
  var hasLenis= typeof window.Lenis !== 'undefined';
  function lerp(a,b,t){return a+(b-a)*t;}
  function clamp(v,a,b){return v<a?a:(v>b?b:v);}

  /* ── boot state ─────────────────────────────────────────────────────────
     BOOTED flips once the engine has run. It gates the preloader so a
     section re-injection in the editor can never drop a full-screen overlay
     back over a live page (trap E).                                        */
  var BOOTED = false;

  /* ══════════ PRELOADER (vanilla, no dependency) ══════════ */
  (function(){
    /* The preloader is a section a merchant can switch OFF. It is also the
       only caller of startHeroIntro(), so without this the hero copy stays
       parked at its CSS start state forever and the section renders empty. */
    var pre=$('#preloader'); if(!pre){ startHeroIntro(); return; }
    var letters=$$('#preWord span'), num=$('#preNum'), bar=$('#preBar');
    var start=null, DUR=1350;
    // animate letters in with tiny stagger via inline style (no GSAP needed)
    letters.forEach(function(l,i){
      l.style.transition='transform .7s cubic-bezier(.22,1,.36,1) '+(i*0.08)+'s, opacity .7s ease '+(i*0.08)+'s';
    });
    requestAnimationFrame(function(){
      letters.forEach(function(l){ l.style.transform='translateY(0)'; l.style.opacity='1'; });
    });
    function step(ts){
      if(start===null) start=ts;
      var p=clamp((ts-start)/DUR,0,1);
      var eased=1-Math.pow(1-p,3);
      if(num) num.textContent=(eased>=1?'100':('0'+Math.round(eased*99)).slice(-2));
      if(bar) bar.style.transform='scaleX('+eased+')';
      if(p<1){ requestAnimationFrame(step); }
      else { finish(); }
    }
    var finished=false;
    function finish(){
      if(finished) return; finished=true;
      setTimeout(function(){
        pre.classList.add('done');
        setTimeout(function(){ if(pre&&pre.parentNode) pre.parentNode.removeChild(pre); }, 720);
        startHeroIntro();
      }, 240);
    }
    if(reduce){ if(pre&&pre.parentNode) pre.parentNode.removeChild(pre); setTimeout(startHeroIntro,10); }
    else { requestAnimationFrame(step); }
    // absolute safety net
    setTimeout(finish, 2300);
  })();

  var heroStarted=false;

  /* The CSS parks the hero out of view — the eyebrow at translateY(120%), each
     title line at 104%, sub and tags at opacity 0 — and startHeroIntro() is the
     only thing that brings them back. It runs once, guarded by heroStarted.

     In the theme editor a section is re-rendered on every setting change, so the
     hero comes back at those parked values while the guard says the intro has
     already played. Result: change any hero setting and the copy vanishes for
     good. settleHero() snaps it to the finished state instead of replaying the
     animation, which would otherwise re-run on every keystroke. */
  function settleHero(){
    var eb = $$('.hero-eye .eyebrow'),
        ln = $$('.hero-title .hl span'),
        sb = $$('.hero-sub, .hero-tags');
    if(hasGSAP){
      /* y:0 only — adding clearProps:'transform' here reverts to the CSS
         translateY(104%) the instant after setting it, which is the whole
         thing we are trying to undo. */
      gsap.set(eb.concat(ln),{y:0});
      gsap.set(sb,{opacity:1,y:0});
    } else {
      eb.concat(ln).forEach(function(n){ n.style.transform='none'; });
      sb.forEach(function(n){ n.style.opacity='1'; n.style.transform='none'; });
    }
  }

  function startHeroIntro(){
    if(heroStarted) return; heroStarted=true;
    if(hasGSAP && !reduce){
      var tl=gsap.timeline({defaults:{ease:'power4.out'}});
      /* NB: the CSS parks these with transform:translateY(104%/120%). The browser
         resolves that to a PIXEL matrix, so GSAP reads y:197px / yPercent:0 — a
         tween to yPercent:0 was animating 0->0 and never moved the title at all.
         Animate y, which is the property GSAP actually sees. */
      tl.to('.hero-eye .eyebrow',{y:0,duration:0.9},0.05)
        .to('.hero-title .hl span',{y:0,duration:1.15,stagger:0.12},0.1)
        .to('.hero-sub',{opacity:1,y:0,duration:1,ease:'power2.out'},0.5)
        .to('.hero-tags',{opacity:1,y:0,duration:1,ease:'power2.out'},0.62);
      gsap.set('.hero-sub,.hero-tags',{y:16});
    } else {
      $$('.hero-eye .eyebrow').forEach(function(n){n.style.transform='none';});
      $$('.hero-title .hl span').forEach(function(n){n.style.transform='none';});
      $('.hero-sub')&&($('.hero-sub').style.opacity='1');
      $('.hero-tags')&&($('.hero-tags').style.opacity='1');
    }
  }

  /* ══════════ LIVE CLOCK (schedule engine) ══════════ */
  var DAYNAMES=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  function serviceOpen(now){
    var d=now.getDay(), mins=now.getHours()*60+now.getMinutes();
    // open windows: Thu19:00->Fri01:00, Fri19:00->Sat02:00, Sat19:00->Sun02:00
    var open=false, closeLabel='', night=d;
    if(d===4 && mins>=1140){open=true;closeLabel='1AM';night=4;}
    else if(d===5 && mins<60){open=true;closeLabel='1AM';night=4;}      // early Fri = Thu service
    else if(d===5 && mins>=1140){open=true;closeLabel='2AM';night=5;}
    else if(d===6 && mins<120){open=true;closeLabel='2AM';night=5;}     // early Sat = Fri service
    else if(d===6 && mins>=1140){open=true;closeLabel='2AM';night=6;}
    else if(d===0 && mins<120){open=true;closeLabel='2AM';night=6;}     // early Sun = Sat service
    return open?{open:true,closeLabel:closeLabel,night:night}:{open:false};
  }
  function nextDoors(now){
    for(var add=0;add<8;add++){
      var c=new Date(now.getFullYear(),now.getMonth(),now.getDate()+add,19,0,0,0);
      var wd=c.getDay();
      if((wd===4||wd===5||wd===6) && c.getTime()>now.getTime()) return c;
    }
    return null;
  }
  function pad2(n){return ('0'+n).slice(-2);}
  function fmtCount(ms){
    if(ms<0) ms=0;
    var s=Math.floor(ms/1000);
    var d=Math.floor(s/86400); s-=d*86400;
    var h=Math.floor(s/3600); s-=h*3600;
    var m=Math.floor(s/60); s-=m*60;
    return pad2(d)+':'+pad2(h)+':'+pad2(m)+':'+pad2(s);
  }
  var clockTargets={
    navTxt:$('#navChipTxt'),
    wtDay:$('#wtDay'), wtCount:$('#wtCount'), wtState:$('#wtState'),
    hsState:$('#hsStateTxt'), hsBig:$('#hsBig'), hsCount:$('#hsCount')
  };
  var landingIdx=4; // default Thursday
  function tickClock(){
    var now=new Date();
    var st=serviceOpen(now);
    if(st.open){
      var dayNm=DAYNAMES[st.night];
      if(clockTargets.navTxt) clockTargets.navTxt.textContent='Open now · until '+st.closeLabel;
      if(clockTargets.wtDay) clockTargets.wtDay.textContent=dayNm;
      if(clockTargets.wtCount) clockTargets.wtCount.textContent='Open now';
      if(clockTargets.wtState) clockTargets.wtState.textContent='Doors are open · until '+st.closeLabel;
      if(clockTargets.hsState) clockTargets.hsState.textContent='Open now';
      if(clockTargets.hsBig) clockTargets.hsBig.textContent='The room is open';
      if(clockTargets.hsCount) clockTargets.hsCount.textContent='Until '+st.closeLabel;
      landingIdx=st.night;
    } else {
      var nd=nextDoors(now);
      if(nd){
        var idx=nd.getDay(); landingIdx=idx;
        var dayNm2=DAYNAMES[idx];
        var cstr=fmtCount(nd.getTime()-now.getTime());
        if(clockTargets.navTxt) clockTargets.navTxt.textContent='Next: '+dayNm2+' 7PM';
        if(clockTargets.wtDay) clockTargets.wtDay.textContent=dayNm2;
        if(clockTargets.wtCount) clockTargets.wtCount.textContent=cstr;
        if(clockTargets.wtState) clockTargets.wtState.textContent='Days : Hrs : Min : Sec';
        if(clockTargets.hsState) clockTargets.hsState.textContent='Next service';
        if(clockTargets.hsBig) clockTargets.hsBig.textContent=dayNm2+' at seven';
        if(clockTargets.hsCount) clockTargets.hsCount.textContent=cstr;
      }
    }
  }

  /* ══════════ WEEK DIAL build ══════════ */
  var DAY3=['SUN','MON','TUE','WED','THU','FRI','SAT'];
  var dialAngles=[];
  (function buildDial(){
    var svg=$('#wtSvg'); if(!svg) return;
    var cx=200, cy=200, rLabel=150, rDot=176, rTickIn=182, rTickOut=194;
    var labelG=$('#dayLabels'), tickG=$('#tickRing');
    var svgNS='http://www.w3.org/2000/svg';
    for(var i=0;i<7;i++){
      var th=i*(360/7); dialAngles.push(th);
      var rad=(th-90)*Math.PI/180; // 0 at top
      // label group
      var g=document.createElementNS(svgNS,'g');
      g.setAttribute('class','day-g'); g.setAttribute('data-i',i);
      var lx=cx+rLabel*Math.cos(rad), ly=cy+rLabel*Math.sin(rad);
      var dx=cx+rDot*Math.cos(rad), dy=cy+rDot*Math.sin(rad);
      var t=document.createElementNS(svgNS,'text');
      t.setAttribute('class','day-label'); t.setAttribute('x',lx.toFixed(1)); t.setAttribute('y',(ly+4).toFixed(1));
      t.setAttribute('text-anchor','middle'); t.textContent=DAY3[i];
      var dot=document.createElementNS(svgNS,'circle');
      dot.setAttribute('class','day-dot'); dot.setAttribute('cx',dx.toFixed(1)); dot.setAttribute('cy',dy.toFixed(1)); dot.setAttribute('r','3.4');
      var pulse=document.createElementNS(svgNS,'circle');
      pulse.setAttribute('class','day-pulse'); pulse.setAttribute('cx',dx.toFixed(1)); pulse.setAttribute('cy',dy.toFixed(1)); pulse.setAttribute('r','7');
      pulse.style.transformOrigin=dx.toFixed(1)+'px '+dy.toFixed(1)+'px';
      g.appendChild(pulse); g.appendChild(dot); g.appendChild(t);
      labelG.appendChild(g);
    }
    // decorative ticks
    for(var k=0;k<56;k++){
      var ta=k*(360/56)*Math.PI/180;
      var x1=cx+rTickIn*Math.cos(ta), y1=cy+rTickIn*Math.sin(ta);
      var x2=cx+rTickOut*Math.cos(ta), y2=cy+rTickOut*Math.sin(ta);
      var ln=document.createElementNS(svgNS,'line');
      ln.setAttribute('class','dial-tick');
      ln.setAttribute('x1',x1.toFixed(1)); ln.setAttribute('y1',y1.toFixed(1));
      ln.setAttribute('x2',x2.toFixed(1)); ln.setAttribute('y2',y2.toFixed(1));
      ln.style.opacity=(k%7===0)?'0.6':'0.22';
      tickG.appendChild(ln);
    }
  })();
  function igniteDays(landing){
    $$('#dayLabels .day-g').forEach(function(g){
      var i=parseInt(g.getAttribute('data-i'),10);
      if(i===4||i===5||i===6) g.classList.add('ignite'); else g.classList.remove('ignite');
      g.classList.toggle('landing', i===landing);
    });
  }

  /* ══════════ CURSOR ══════════ */
  (function(){
    if(window.matchMedia && window.matchMedia('(hover:none)').matches) return;
    var cur=$('#cursor'), dot=$('#cursorDot');
    if(!cur||!dot) return;
    var mx=window.innerWidth/2, my=window.innerHeight/2, cxp=mx, cyp=my, vis=false;
    window.addEventListener('mousemove',function(e){
      mx=e.clientX; my=e.clientY;
      dot.style.transform='translate('+mx+'px,'+my+'px)';
      if(!vis){vis=true;cur.style.opacity='1';dot.style.opacity='1';}
    },{passive:true});
    (function raf(){ cxp=lerp(cxp,mx,0.18); cyp=lerp(cyp,my,0.18);
      cur.style.transform='translate('+cxp+'px,'+cyp+'px)'; requestAnimationFrame(raf); })();
    $$('a, button, .mag, .faq-q, .rail-item, .hours-row, .menu-row, .tp-dish').forEach(function(el){
      el.addEventListener('mouseenter',function(){document.body.classList.add('cur-lg');});
      el.addEventListener('mouseleave',function(){document.body.classList.remove('cur-lg');});
    });
  })();

  /* ══════════ EMBER CANVAS factory ══════════ */
  function makeEmbers(canvas, opts){
    if(!canvas || reduce) return;
    var ctx=canvas.getContext('2d'); if(!ctx) return;
    var DPR=Math.min(window.devicePixelRatio||1,2);
    var W=0,H=0,parts=[],running=false,rafId=null;
    var COUNT=opts.count||46, up=opts.up||0.35, col=opts.color||[138,95,58];
    function size(){
      var r=canvas.getBoundingClientRect();
      W=canvas.width=Math.max(1,Math.round(r.width*DPR));
      H=canvas.height=Math.max(1,Math.round(r.height*DPR));
    }
    function spawn(y){
      return {x:Math.random()*W, y:(y===undefined?Math.random()*H:y),
        r:(Math.random()*1.8+0.6)*DPR, vy:-(Math.random()*up+0.12)*DPR,
        vx:(Math.random()-0.5)*0.25*DPR, a:Math.random()*0.5+0.15, ph:Math.random()*6.28};
    }
    function init(){ size(); parts=[]; for(var i=0;i<COUNT;i++) parts.push(spawn()); }
    function frame(){
      if(!running) return;
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<parts.length;i++){
        var p=parts[i];
        p.y+=p.vy; p.x+=p.vx; p.ph+=0.04;
        var fl=0.6+Math.sin(p.ph)*0.4;
        if(p.y< -10){ parts[i]=spawn(H+8); continue; }
        ctx.beginPath();
        ctx.arc(p.x,p.y,p.r,0,6.283);
        ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(p.a*fl).toFixed(3)+')';
        ctx.fill();
      }
      rafId=requestAnimationFrame(frame);
    }
    init();
    window.addEventListener('resize',function(){ init(); },{passive:true});
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ if(!running){running=true;frame();} }
        else { running=false; if(rafId) cancelAnimationFrame(rafId); }
      });
    },{threshold:0.02});
    io.observe(canvas);
  }
  makeEmbers($('#heroCanvas'),{count:38,up:0.3,color:[138,95,58]});
  makeEmbers($('#reserveCanvas'),{count:56,up:0.55,color:[138,95,58]});

  /* ══════════ LENIS + SCROLLTRIGGER ══════════ */
  var lenis=null;
  if(hasST) gsap.registerPlugin(ScrollTrigger);
  if(hasLenis && !reduce){
    lenis=new Lenis({duration:1.1,easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t));},smoothWheel:true});
    window.__lenis=lenis;
    if(hasST){ lenis.on('scroll',ScrollTrigger.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); }); gsap.ticker.lagSmoothing(0); }
    else { function rl(t){ lenis.raf(t); requestAnimationFrame(rl); } requestAnimationFrame(rl); }
  }


  /* ══════════ RE-RUNNABLE SCROLL WIRING ══════════
     Everything that creates a ScrollTrigger / matchMedia lives here so it can
     be torn down and rebuilt as a unit. Nothing else in the engine is re-run:
     Lenis, the clock interval and the DOM listeners are created once.        */
  var WIRED_ST = [];   // ScrollTriggers created by the last wireScroll()
  var WIRED_MM = [];   // gsap.matchMedia() contexts created by the last wireScroll()

  function __wire(){
    /* dark-context cursor invert — lifted out of the cursor module so it is
       rebuilt along with everything else when sections reload */
    // dark-context cursor invert
    if(hasST){
      $$('#triptych, #arc, #menu, #fire, #reserve, #footer').forEach(function(sec){
        ScrollTrigger.create({trigger:sec,start:'top 50%',end:'bottom 50%',
          onToggle:function(self){ document.body.classList.toggle('on-dark', self.isActive); }});
      });
      // parchment sections turn it off
    }

  if(hasST && !reduce){

    /* progress bar */
    var pbar=$('#progress');
    ScrollTrigger.create({trigger:'body',start:'top top',end:'bottom bottom',scrub:true,
      onUpdate:function(s){ if(pbar) pbar.style.width=(s.progress*100)+'%'; }});

    /* nav shrink + chip */
    var nav=$('#nav'), chip=$('#navChip');
    ScrollTrigger.create({trigger:'#hero',start:'bottom 84%',
      onEnter:function(){nav.classList.add('shrunk'); if(chip)chip.classList.add('on');},
      onLeaveBack:function(){nav.classList.remove('shrunk'); if(chip)chip.classList.remove('on');}});

    /* generic reveals */
    $$('.reveal').forEach(function(node){
      if(node.closest('#hero')) return;
      gsap.from(node,{y:34,opacity:0,duration:0.9,ease:'power3.out',
        scrollTrigger:{trigger:node,start:'top 88%'}});
    });

    /* headline line-mask rises */
    if(hasSplit){
      $$('.h2, .intro-big').forEach(function(h){
        try{
          var sp=new SplitText(h,{type:'lines',linesClass:'sl-line'});
          gsap.set(sp.lines,{overflow:'hidden'});
          gsap.set(h,{overflow:'hidden'});
          gsap.from(sp.lines,{yPercent:112,duration:1,stagger:0.12,ease:'power4.out',
            scrollTrigger:{trigger:h,start:'top 87%'}});
        }catch(e){}
      });
    }

    /* fire quote word cascade */
    (function(){
      var q=$('#fireQuote'); if(!q) return;
      if(hasSplit){
        try{
          var sp=new SplitText(q,{type:'words',wordsClass:'word'});
          $$('#fireQuote .word').forEach(function(w){ var inner=document.createElement('span');
            while(w.firstChild) inner.appendChild(w.firstChild); w.appendChild(inner); });
          /* .fire-quote .word span is parked at translateY(105%) by CSS, so tween
             y (px) to 0 rather than from yPercent — see the hero intro note */
          gsap.to('#fireQuote .word span',{y:0,duration:1,stagger:0.09,ease:'power4.out',
            scrollTrigger:{trigger:q,start:'top 82%'}});
        }catch(e){ q.style.opacity=1; }
      }
    })();

    /* reserve title */
    ScrollTrigger.create({trigger:'#reserve',start:'top 66%',once:true,onEnter:function(){
      gsap.to('.res-title .l span',{y:0,duration:1.1,stagger:0.12,ease:'power4.out'});
    }});

    /* velocity skew on menu rows */
    (function(){
      var rows=$$('.menu-row'); if(!rows.length) return;
      var setSkew=gsap.quickTo(rows,'skewY',{duration:0.5,ease:'power3'});
      ScrollTrigger.create({trigger:'#menu',start:'top bottom',end:'bottom top',
        onUpdate:function(s){ var v=clamp(s.getVelocity()/-320,-5,5); setSkew(v); }});
    })();

    /* ── SET PIECE 2: WEEK DIAL ── */
    var mm=gsap.matchMedia(); WIRED_MM.push(mm);
    mm.add('(min-width:821px)',function(){
      var handG=$('#dialHandG'), tickG=$('#tickRing');
      var targetIdx=landingIdx; // captured at build; refreshed below
      var finalRot=dialAngles[targetIdx]+360;
      /* svgOrigin, not transformOrigin: on an SVG element GSAP measures a px
         transformOrigin from that element's own bounding box, so '200px 200px'
         put the hand's pivot outside the ring and swung it off the dial.
         svgOrigin reads the viewBox user space, matching the rotate(a 200 200)
         used by the static mobile fallback below. */
      gsap.set(handG,{svgOrigin:'200 200'});
      gsap.set(tickG,{svgOrigin:'200 200'});
      var dialST=ScrollTrigger.create({trigger:'#weekturns',start:'top top',end:'+=150%',
        pin:'.wt-stage',anticipatePin:1,scrub:0.6,
        onUpdate:function(self){
          var p=self.progress;
          gsap.set(handG,{rotation:finalRot*p});
          gsap.set(tickG,{rotation:-70*p});
          $$('#dayLabels .day-g').forEach(function(g){
            var i=parseInt(g.getAttribute('data-i'),10);
            var lit=(i===4&&p>0.34)||(i===5&&p>0.54)||(i===6&&p>0.74);
            g.classList.toggle('ignite',lit);
            g.classList.toggle('landing', i===landingIdx && p>0.9);
          });
        },
        onLeave:function(){ igniteDays(landingIdx); },
        onLeaveBack:function(){ $$('#dayLabels .day-g').forEach(function(g){g.classList.remove('ignite');g.classList.remove('landing');}); }
      });
      // keep landing target current with clock
      var refresh=setInterval(function(){
        finalRot=dialAngles[landingIdx]+360;
      },1000);
      return function(){ clearInterval(refresh); if(dialST) dialST.kill(true); };
    });
    mm.add('(max-width:820px)',function(){
      /* The dial turns on mobile too, but WITHOUT the pin. Pinning a 100svh
         stage on a phone fights the collapsing address bar: the viewport
         height changes mid-scroll, ScrollTrigger re-measures, and the pin
         jumps. Scrubbing the rotation across the section's own travel gives
         the same turn with none of that — it simply animates as the section
         passes through the viewport rather than holding it still. */
      var handG=$('#dialHandG'), tickG=$('#tickRing');
      if(!handG){ igniteDays(landingIdx); return function(){}; }

      /* attribute transform and GSAP's transform would fight for the same
         attribute, so clear the static landed state before scrubbing */
      handG.removeAttribute('transform');
      gsap.set(handG,{svgOrigin:'200 200'});
      gsap.set(tickG,{svgOrigin:'200 200'});

      var finalRot=dialAngles[landingIdx]+360;
      var mST=ScrollTrigger.create({
        trigger:'#weekturns', start:'top 85%', end:'bottom 55%', scrub:0.6,
        onUpdate:function(self){
          var p=self.progress;
          gsap.set(handG,{rotation:finalRot*p});
          gsap.set(tickG,{rotation:-70*p});
          $$('#dayLabels .day-g').forEach(function(g){
            var i=parseInt(g.getAttribute('data-i'),10);
            var lit=(i===4&&p>0.34)||(i===5&&p>0.54)||(i===6&&p>0.74);
            g.classList.toggle('ignite',lit);
            g.classList.toggle('landing', i===landingIdx && p>0.9);
          });
        },
        onLeave:function(){ igniteDays(landingIdx); }
      });
      /* keep the landing target current with the live clock, same as desktop */
      var mRefresh=setInterval(function(){ finalRot=dialAngles[landingIdx]+360; },1000);
      return function(){
        clearInterval(mRefresh);
        if(mST) mST.kill(true);
        gsap.set(handG,{clearProps:'transform'});
        handG.setAttribute('transform','rotate('+dialAngles[landingIdx]+' 200 200)');
      };
    });

    /* ── SET PIECE 1: TRIPTYCH ── */
    mm.add('(min-width:821px)',function(){
      var track=$('#tripTrack');
      var rail=$$('.rail-item');
      var friR=$$('.trip-panel[data-n="fri"] .reveal');
      var satR=$$('.trip-panel[data-n="sat"] .reveal');
      gsap.set(friR,{opacity:0,y:28}); gsap.set(satR,{opacity:0,y:28});
      var tl=gsap.timeline({defaults:{ease:'none'},
        scrollTrigger:{trigger:'#triptych',start:'top top',end:'+=280%',
          pin:'.trip-stage',anticipatePin:1,scrub:0.6,
          onUpdate:function(self){
            var idx=Math.round(self.progress*2);
            rail.forEach(function(r,i){ r.classList.toggle('active', i===idx); });
          }
        }});
      tl.to(track,{xPercent:-66.667,duration:2,ease:'none'},0)
        .to(friR,{opacity:1,y:0,duration:0.4,ease:'power2.out',stagger:0.05},0.62)
        .to(satR,{opacity:1,y:0,duration:0.4,ease:'power2.out',stagger:0.05},1.5);
      var tripST=tl.scrollTrigger;
      // rail click travel
      var progs=[0.02,0.5,0.97];
      rail.forEach(function(r){
        r.addEventListener('click',function(){
          if(!tripST) return;
          var i=parseInt(r.getAttribute('data-i'),10);
          var y=tripST.start+(tripST.end-tripST.start)*progs[i];
          if(lenis&&lenis.scrollTo) lenis.scrollTo(y,{duration:1.1});
          else window.scrollTo(0,y);
        });
      });
      return function(){ if(tripST) tripST.kill(true); };
    });
    mm.add('(max-width:820px)',function(){
      // stacked, reveal all panels' content
      $$('.trip-panel .reveal').forEach(function(n){ gsap.set(n,{opacity:1,y:0}); });
      return function(){};
    });

    /* ── ARC fill ── */
    (function(){
      var fill=$('#arcFill'), stops=$$('#arc .arc-stop');
      if(!fill) return;
      ScrollTrigger.create({trigger:'#arcTrack',start:'top 78%',end:'bottom 60%',scrub:0.5,
        onUpdate:function(self){
          var p=self.progress;
          var vert=window.matchMedia('(max-width:640px)').matches;
          if(vert){ fill.style.height=(p*100)+'%'; fill.style.width='1px'; }
          else { fill.style.width=(p*100)+'%'; }
          stops.forEach(function(s,i){ s.classList.toggle('lit', p>= (i/(stops.length-1))-0.02 ); });
        }});
    })();

    /* footer marquee drift */
    var ft=$('#footTrack');
    if(ft){ gsap.to(ft,{xPercent:-50,ease:'none',
      scrollTrigger:{trigger:'#footer',start:'top bottom',end:'bottom top',scrub:1}}); }

  } else {
    /* reduced motion / no GSAP: reveal everything, static set pieces */
    $$('.reveal').forEach(function(n){ n.style.opacity=1; n.style.transform='none'; });
    $$('.hero-title .hl span, .res-title .l span').forEach(function(n){ n.style.transform='none'; });
    $$('.fire-quote .word span').forEach(function(n){ n.style.transform='none'; });
    var handG0=$('#dialHandG');
    if(handG0) handG0.setAttribute('transform','rotate('+dialAngles[landingIdx]+' 200 200)');
    igniteDays(landingIdx);
    $$('#arc .arc-stop').forEach(function(s){ s.classList.add('lit'); });
    var af=$('#arcFill'); if(af) af.style.width='100%';
    // simple nav shrink
    var nav2=$('#nav'), chip2=$('#navChip');
    window.addEventListener('scroll',function(){
      if(window.scrollY>window.innerHeight*0.7){ nav2.classList.add('shrunk'); if(chip2)chip2.classList.add('on'); }
      else { nav2.classList.remove('shrunk'); if(chip2)chip2.classList.remove('on'); }
    },{passive:true});
  }
  }

  /* Diff ScrollTrigger.getAll() around __wire() so every trigger it creates is
     tracked without editing a single create() call. */
  function wireScroll(){
    var before = [];
    if (hasST) before = ScrollTrigger.getAll().slice();
    WIRED_MM = [];
    __wire();
    if (hasST) {
      WIRED_ST = ScrollTrigger.getAll().filter(function(st){
        return before.indexOf(st) === -1;
      });
    }
  }

  function killScroll(){
    WIRED_MM.forEach(function(m){ try { m.revert(); } catch(e){} });
    WIRED_ST.forEach(function(st){ try { st.kill(true); } catch(e){} });
    WIRED_MM = [];
    WIRED_ST = [];
  }

  /* Which section owns a trigger element, for precise unload teardown */
  function ownerOf(el){
    if (!el || !el.closest) return null;
    var host = el.closest('[data-section-id]');
    return host ? host.getAttribute('data-section-id') : null;
  }
  function killSection(id){
    if (!id) return;
    WIRED_ST = WIRED_ST.filter(function(st){
      var trg = st.trigger || (st.vars && st.vars.trigger);
      if (trg && typeof trg === 'object' && ownerOf(trg) === id) {
        try { st.kill(true); } catch(e){}
        return false;
      }
      return true;
    });
  }

  wireScroll();


  /* ══════════ CLOCK start + dial ignite ══════════ */
  igniteDays(landingIdx);
  tickClock();
  setInterval(tickClock,1000);

  /* ══════════ SMOOTH ANCHORS ══════════ */
  $$('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('href'); if(id.length<2) return;
      var t=document.querySelector(id); if(!t) return;
      e.preventDefault();
      if(lenis&&lenis.scrollTo) lenis.scrollTo(t,{offset:-8});
      else t.scrollIntoView({behavior:reduce?'auto':'smooth'});
    });
  });

  /* ══════════ FAQ ══════════ */
  $$('.faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.closest('.faq-item'); var a=item.querySelector('.faq-a');
      var isOpen=item.classList.contains('open');
      $$('.faq-item.open').forEach(function(o){ o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight=null; });
      if(!isOpen){ item.classList.add('open'); a.style.maxHeight=a.scrollHeight+'px'; }
    });
  });

  /* ══════════ MAGNETIC BUTTONS ══════════ */
  if(!reduce && !(window.matchMedia && window.matchMedia('(hover:none)').matches)){
    $$('.btn.mag').forEach(function(b){
      b.addEventListener('mousemove',function(e){
        var r=b.getBoundingClientRect();
        var x=(e.clientX-r.left-r.width/2)*0.28, y=(e.clientY-r.top-r.height/2)*0.34;
        if(hasGSAP) gsap.to(b,{x:x,y:y,duration:0.4,ease:'power3'});
        else b.style.transform='translate('+x+'px,'+y+'px)';
      });
      b.addEventListener('mouseleave',function(){
        if(hasGSAP) gsap.to(b,{x:0,y:0,duration:0.5,ease:'elastic.out(1,0.4)'});
        else b.style.transform='none';
      });
    });
  }

  /* ══════════ EASTER EGG: press 3 → three ember flares ══════════ */
  window.addEventListener('keydown',function(e){
    if(e.key==='3'){
      for(var i=0;i<3;i++){
        (function(n){
          var fl=document.createElement('div');
          var lx=[26,50,74][n];
          fl.style.cssText='position:fixed;left:'+lx+'%;top:62%;z-index:9995;pointer-events:none;'+
            'width:40vw;height:40vw;transform:translate(-50%,-50%) scale(.4);opacity:0;border-radius:50%;'+
            'background:radial-gradient(circle at center,rgba(138,95,58,.5),rgba(36,26,17,0) 60%)';
          document.body.appendChild(fl);
          if(hasGSAP&&!reduce){
            gsap.to(fl,{opacity:1,scale:1,duration:0.5,ease:'power2.out',delay:n*0.12,onComplete:function(){
              gsap.to(fl,{opacity:0,duration:1.1,ease:'power2.in',onComplete:function(){ fl.remove(); }});
            }});
          } else { fl.style.opacity='1'; setTimeout(function(){ fl.remove(); },500); }
        })(i);
      }
    }
  });

  /* ══════════ REFRESH on fonts + load ══════════ */
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ if(hasST) ScrollTrigger.refresh(); }); }

  /* ══════════ MOBILE DRAWER ══════════ */
(function(){
  "use strict";
  var burger=document.getElementById('navBurger');
  var drawer=document.getElementById('drawer');
  var closeBtn=document.getElementById('drawerClose');
  if(!burger||!drawer||!closeBtn) return;
  var lastFocus=null;

  function focusables(){
    return Array.prototype.slice.call(
      drawer.querySelectorAll('a[href],button:not([disabled])')
    ).filter(function(el){ return el.offsetParent!==null; });
  }

  function setOpen(on){
    drawer.classList.toggle('on',on);
    drawer.setAttribute('aria-hidden',on?'false':'true');
    burger.setAttribute('aria-expanded',on?'true':'false');
    document.documentElement.style.overflow=on?'hidden':'';
    /* the page runs Lenis smooth scroll; leaving it live under the drawer lets
       the body scroll behind it, and breaks scrollTo on the way out */
    var l=window.__lenis;
    if(l){ if(on){ if(l.stop) l.stop(); } else if(l.start){ l.start(); } }
    if(on){ lastFocus=document.activeElement; setTimeout(function(){ closeBtn.focus(); },60); }
    else if(lastFocus&&lastFocus.focus){ lastFocus.focus(); }
  }

  burger.addEventListener('click',function(){ setOpen(true); });
  closeBtn.addEventListener('click',function(){ setOpen(false); });

  document.addEventListener('keydown',function(e){
    if(!drawer.classList.contains('on')) return;
    if(e.key==='Escape'){ setOpen(false); return; }
    if(e.key!=='Tab') return;
    var f=focusables(); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  });

  /* capture phase: close (and restart Lenis) BEFORE the theme's smooth-anchor
     handler fires on the link itself, otherwise it calls scrollTo on a stopped
     instance and the jump silently does nothing */
  drawer.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href]');
    if(a) setOpen(false);
  },true);

  window.addEventListener('resize',function(){
    if(drawer.classList.contains('on')&&window.innerWidth>820) setOpen(false);
  });
})();

  /* ══════════ MEGA MENU ══════════
     Bound by delegation on `document`, not to the trigger element. The header
     lives in a section GROUP, so the theme editor can re-render it at any time
     and any listener held on the old node is lost. Delegation survives that
     without needing to re-bind on shopify:section:load. */
  (function () {
    function panel()   { return document.getElementById('megaPanel'); }
    function trigger() { return document.getElementById('megaTrigger'); }

    function setMega(open) {
      var p = panel(), t = trigger();
      if (!p || !t) return;
      p.hidden = false;              /* [hidden] must come off before it can animate */
      p.classList.toggle('on', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        /* put [hidden] back once it has faded, so it leaves the a11y tree */
        setTimeout(function () {
          if (p && !p.classList.contains('on')) p.hidden = true;
        }, 400);
      }
    }

    document.addEventListener('click', function (e) {
      var t = trigger(), p = panel();
      if (!t || !p) return;
      if (t.contains(e.target)) {
        e.preventDefault();
        setMega(!p.classList.contains('on'));
        return;
      }
      /* a link inside the panel closes it; so does anything outside */
      if (p.classList.contains('on') && (!p.contains(e.target) || e.target.closest('a,button'))) {
        setMega(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      var p = panel();
      if (e.key === 'Escape' && p && p.classList.contains('on')) {
        setMega(false);
        var t = trigger(); if (t) t.focus();
      }
    });
  })();

  /* ══════════ CTA DOCK REVEAL ══════════ */
  (function(){
    function run(){
      var d=document.querySelector('.alia-cta-dock'); if(!d) return;
      function reveal(){ d.classList.add('revealed'); }
      var SEL='#preloader,#intro,#introStatement,[id*="preload" i],[class*="preloader" i],[class*="intro-idx"],[class*="intro-col"],[class*="intro-grid"],.intro-statement,.d-veil,.hero-veil,.tex-veil,.pre-veil,[class*="veil"]';
      var pre=document.querySelector(SEL);
      if(pre){
        var start=Date.now();
        var iv=setInterval(function(){
          var el=document.querySelector(SEL), gone=!el;
          if(el){ var cs=getComputedStyle(el); gone=(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.1); }
          if(gone || (Date.now()-start)>6000){ reveal(); clearInterval(iv); }
        },200);
      } else {
        if(document.readyState==='complete'){ setTimeout(reveal,700); }
        else { window.addEventListener('load',function(){ setTimeout(reveal,700); }); }
      }
    }
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  })();

  /* ══════════ GALLERY LIGHTBOX ══════════
     Click a corporate photo to see it full size. Delegated on `document` for
     the same reason as the mega menu: the gallery is a section the editor can
     re-render at will, and a listener held on the old nodes would be lost.
     The overlay itself is built once, lazily, on first open. */
  (function () {
    var box = null, imgEl, capEl, countEl, shots = [], at = 0, opener = null;

    function build() {
      if (box) return;
      box = document.createElement('div');
      box.id = 'alia-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Image viewer');
      box.innerHTML =
        '<span class="lb-count"></span>' +
        '<button type="button" class="lb-btn lb-x" aria-label="Close">✕</button>' +
        '<button type="button" class="lb-btn lb-prev" aria-label="Previous image"><span class="lb-arw"></span></button>' +
        '<button type="button" class="lb-btn lb-next" aria-label="Next image"><span class="lb-arw"></span></button>' +
        '<img alt="" /><p class="lb-cap"></p>';
      document.body.appendChild(box);
      imgEl   = box.querySelector('img');
      capEl   = box.querySelector('.lb-cap');
      countEl = box.querySelector('.lb-count');
      box.querySelector('.lb-x').addEventListener('click', close);
      box.querySelector('.lb-prev').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      box.querySelector('.lb-next').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      /* click the backdrop, but not the photo itself */
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
    }

    function show(i) {
      at = (i + shots.length) % shots.length;
      var b = shots[at];
      imgEl.src = b.getAttribute('data-full');
      imgEl.alt = b.getAttribute('aria-label') || '';
      var cap = b.getAttribute('data-cap') || '';
      capEl.textContent = cap;
      capEl.style.display = cap ? '' : 'none';
      countEl.textContent = (at + 1) + ' / ' + shots.length;
      var many = shots.length > 1;
      box.querySelector('.lb-prev').hidden = !many;
      box.querySelector('.lb-next').hidden = !many;
      countEl.hidden = !many;
    }
    function step(d) { show(at + d); }

    function open(btn) {
      build();
      /* re-read on every open so an editor re-render is picked up */
      shots = [].slice.call(document.querySelectorAll('.gal-open[data-full]'));
      var i = shots.indexOf(btn);
      if (i < 0) { shots = [btn]; i = 0; }
      opener = btn;
      show(i);
      box.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      var l = window.__lenis; if (l && l.stop) l.stop();
      box.querySelector('.lb-x').focus();
    }

    function close() {
      if (!box) return;
      box.classList.remove('on');
      imgEl.removeAttribute('src');          /* stop a large decode in the background */
      document.documentElement.style.overflow = '';
      var l = window.__lenis; if (l && l.start) l.start();
      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.gal-open[data-full]');
      if (btn) { e.preventDefault(); open(btn); }
    });

    document.addEventListener('keydown', function (e) {
      if (!box || !box.classList.contains('on')) return;
      if (e.key === 'Escape')     { close(); }
      else if (e.key === 'ArrowLeft')  { step(-1); }
      else if (e.key === 'ArrowRight') { step(1); }
      else if (e.key === 'Tab') {
        /* keep focus inside the overlay */
        var f = [].slice.call(box.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ══════════ SHOPIFY SECTION LIFECYCLE ══════════
     The choreography is global, so a section landing or leaving invalidates
     pin spacing for the whole page. Kill this engine's triggers, rebuild the
     cross-section bindings, then refresh (Route B rule 4).                   */
  BOOTED = true;

  function rebuild(){
    if (!hasST) return;
    killScroll();
    wireScroll();
    ScrollTrigger.refresh();
  }

  document.addEventListener('shopify:section:load', function(e){
    /* trap E: an injected header section brings a fresh #preloader with it.
       The page is already up, so dismiss it on sight. */
    var pre = document.getElementById('preloader');
    if (BOOTED && pre) {
      pre.classList.add('done');
      if (pre.parentNode) pre.parentNode.removeChild(pre);
    }
    /* a re-rendered hero comes back parked at its CSS start state, and the
       intro's one-time guard means nothing will ever un-park it */
    if (BOOTED && document.querySelector('.hero-title .hl span')) settleHero();
    rebuild();
  });

  document.addEventListener('shopify:section:unload', function(e){
    if (e && e.detail && e.detail.sectionId) killSection(e.detail.sectionId);
    rebuild();
  });

  /* editor preview: re-measure when a block is selected or reordered */
  document.addEventListener('shopify:section:reorder', rebuild);
  document.addEventListener('shopify:block:select', function(){
    if (hasST) ScrollTrigger.refresh();
  });
})();
